import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getPublishedEventUrl } from '@/store/slices/project';

const useGetProjectPublishedStatus = () => {
  const dispatch = useAppDispatch();
  const fetching = useRef(false);

  const eventUuid = useAppSelector((state) => state.project.workingProject?.uuid);

  useEffect(() => {
    if (fetching.current || !eventUuid) return;
    fetching.current = true;
    dispatch(getPublishedEventUrl({ eventUuid }));
  }, [dispatch, eventUuid]);
};

export default useGetProjectPublishedStatus;
